module.exports = __webpack_public_path__ + "img/LOGO-OGMIA-WHITE.2c248c3e.svg";